import React, { Fragment } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import styled from "styled-components";
import { mediaQueries } from "./theme";

const MainContent = styled(Container)`
  margin: 17px auto auto auto;
  ${mediaQueries.desktop} {
    padding-left: 30px;
    padding-right: 30px;
    margin-top: 17px;
    max-width: 1400px;
  }
`;

export const Main = ({ children }) => {
  return (
    <MainContent tag={"main"} className={"px-lg-5 position-relative"} fluid>
      {children}
    </MainContent>
  );
};

const Layout = ({ celebrities, backPath, children }) => {
  return (
    <>
      <Header celebrities={celebrities} />

      {backPath && (
        <Main>
          <Row>
            <Col xs={12} className={"mx-auto"}>
              <Link to={backPath.pathname} state={backPath.state}>
                Retour
              </Link>
            </Col>
          </Row>
        </Main>
      )}
      {children}
      <Footer />
    </>
  );
};

export default Layout;
